import { Game, GameCategory } from '../types/game';

// Base game URL - all games use this for now
const BASE_GAME_URL = 'https://gamebar.thejinjar.com/wp/games/ScaryRun/';

// Helper function to generate game images with better dummy images
const getGameImage = (title: string, seed: number) => {
  // Using Picsum Photos for high-quality dummy images with different seeds for variety
  // Each game gets a unique image based on seed
  return `https://picsum.photos/seed/${seed}/400/300`;
};

export const games: Game[] = [
  // New Releases
  {
    id: 'fire-truck',
    title: 'Fire Truck',
    image: getGameImage('Fire Truck', 101),
    rating: 4,
    category: 'new',
    gameUrl: BASE_GAME_URL,
    isFavorite: false,
  },
  {
    id: 'scary-run',
    title: 'Scary Run!',
    image: getGameImage('Scary Run', 102),
    rating: 4,
    category: 'new',
    gameUrl: BASE_GAME_URL,
    isFavorite: false,
  },
  {
    id: 'speed-racer',
    title: 'Speed Racer',
    image: getGameImage('Speed Racer', 103),
    rating: 4,
    category: 'new',
    gameUrl: BASE_GAME_URL,
    isFavorite: false,
  },
  {
    id: 'swing-birds',
    title: 'Swing Birds',
    image: getGameImage('Swing Birds', 104),
    rating: 4,
    category: 'new',
    gameUrl: BASE_GAME_URL,
    isFavorite: false,
  },
  {
    id: 'track-racer',
    title: 'Track Racer',
    image: getGameImage('Track Racer', 105),
    rating: 4,
    category: 'new',
    gameUrl: BASE_GAME_URL,
    isFavorite: false,
  },
  {
    id: 'racing-champion',
    title: 'Racing Champion',
    image: getGameImage('Racing Champion', 106),
    rating: 5,
    category: 'new',
    gameUrl: BASE_GAME_URL,
    isFavorite: false,
  },
  // Arcade Games
  {
    id: 'air-hockey',
    title: 'Air Hockey',
    image: getGameImage('Air Hockey', 201),
    rating: 4,
    category: 'arcade',
    gameUrl: BASE_GAME_URL,
    isFavorite: false,
  },
  {
    id: 'airport-rush',
    title: 'Airport Rush',
    image: getGameImage('Airport Rush', 202),
    rating: 5,
    category: 'arcade',
    gameUrl: BASE_GAME_URL,
    isFavorite: false,
  },
  {
    id: 'billiard',
    title: 'Billiard',
    image: getGameImage('Billiard', 203),
    rating: 5,
    category: 'arcade',
    gameUrl: BASE_GAME_URL,
    isFavorite: false,
  },
  {
    id: 'panda-lo',
    title: 'Panda Lo',
    image: getGameImage('Panda Lo', 204),
    rating: 5,
    category: 'arcade',
    gameUrl: BASE_GAME_URL,
    isFavorite: false,
  },
  {
    id: 'pops-billiards',
    title: "Pop's Billiards",
    image: getGameImage('Pops Billiards', 205),
    rating: 5,
    category: 'arcade',
    gameUrl: BASE_GAME_URL,
    isFavorite: false,
  },
  {
    id: 'sea-animals',
    title: 'Sea Animals!',
    image: getGameImage('Sea Animals', 206),
    rating: 5,
    category: 'arcade',
    gameUrl: BASE_GAME_URL,
    isFavorite: false,
  },
  // Action Games
  {
    id: 'war-battleship',
    title: 'War Battleship',
    image: getGameImage('War Battleship', 301),
    rating: 4,
    category: 'action',
    gameUrl: BASE_GAME_URL,
    isFavorite: false,
  },
  {
    id: 'space-invaders',
    title: 'Space Invaders',
    image: getGameImage('Space Invaders', 302),
    rating: 4,
    category: 'action',
    gameUrl: BASE_GAME_URL,
    isFavorite: false,
  },
  {
    id: 'zombie-shooter',
    title: 'Zombie Shooter',
    image: getGameImage('Zombie Shooter', 303),
    rating: 5,
    category: 'action',
    gameUrl: BASE_GAME_URL,
    isFavorite: false,
  },
  {
    id: 'ninja-warrior',
    title: 'Ninja Warrior',
    image: getGameImage('Ninja Warrior', 304),
    rating: 4,
    category: 'action',
    gameUrl: BASE_GAME_URL,
    isFavorite: false,
  },
  {
    id: 'super-hero',
    title: 'Super Hero',
    image: getGameImage('Super Hero', 305),
    rating: 5,
    category: 'action',
    gameUrl: BASE_GAME_URL,
    isFavorite: false,
  },
];

export const gameCategories: GameCategory[] = [
  {
    id: 'new-releases',
    name: 'New Releases',
    games: games.filter(g => g.category === 'new'),
  },
  {
    id: 'arcade',
    name: 'Arcade Games',
    games: games.filter(g => g.category === 'arcade'),
  },
  {
    id: 'action',
    name: 'Action Games',
    games: games.filter(g => g.category === 'action'),
  },
];

// Get featured games (top rated)
export const getFeaturedGames = (): Game[] => {
  return games
    .filter(g => g.rating >= 4.5)
    .sort((a, b) => b.rating - a.rating)
    .slice(0, 6);
};

// Get trending games (most popular)
export const getTrendingGames = (): Game[] => {
  return games
    .filter(g => g.rating >= 4)
    .sort(() => Math.random() - 0.5)
    .slice(0, 5);
};

